import { render } from "./PracticeScene.vue?vue&type=template&id=0952940f&scoped=true"
import script from "./PracticeScene.vue?vue&type=script&lang=js"
export * from "./PracticeScene.vue?vue&type=script&lang=js"

import "./PracticeScene.vue?vue&type=style&index=0&id=0952940f&scoped=true&lang=css"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0952940f"]])

export default __exports__